/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type ProjectToolTipFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly hexType: Types.HexType;
  readonly currentDraft: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly title: string;
    readonly description: string | null;
  };
  readonly lastPublishedVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
  } | null;
};

export const ProjectToolTipFragmentDoc = /*#__PURE__*/ gql`
  fragment ProjectToolTipFragment on Hex {
    id
    hexType
    currentDraft {
      id
      title
      description
    }
    lastPublishedVersion {
      id
    }
  }
`;
